exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctx_92cd2dc{position:fixed;top:-99999px;left:0;background-color:#fff;border-radius:4px;border-radius:var(--radius);box-shadow:0 3px 5px rgba(0,0,0,.1);border:1px solid #f0f2f8;border:1px solid var(--color-border);z-index:999}.ctx_92cd2dc .item_30af92f{padding:5px 12px;cursor:pointer;white-space:nowrap}.ctx_92cd2dc .item_30af92f:hover{background-color:#eee}", ""]);

// exports
exports.locals = {
	"ctx": "ctx_92cd2dc",
	"item": "item_30af92f"
};